import { render, staticRenderFns } from "./SweetSpotSaved.vue?vue&type=template&id=31a5da8d&scoped=true"
import script from "./SweetSpotSaved.vue?vue&type=script&lang=js"
export * from "./SweetSpotSaved.vue?vue&type=script&lang=js"
import style0 from "./SweetSpotSaved.vue?vue&type=style&index=0&id=31a5da8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31a5da8d",
  null
  
)

export default component.exports